module.exports = __webpack_public_path__ + "static/media/statement-hero-school-of-athens.e67f699d.jpg";